module.exports = __webpack_public_path__ + "img/41bfa1fab4dd413b9575e2c83e02426c-1024.cc220f11.jpg";